import { Tag } from '@arco-design/mobile-react';
import type { ReactNode } from 'react';

export type MobileTagTone = 'blue' | 'green' | 'red' | 'purple' | 'gray';

const tagTones: Record<MobileTagTone, { color: string; background: string; border: string }> = {
  blue: { color: '#1768ff', background: '#e8f3ff', border: '#b7d4ff' },
  green: { color: '#00a870', background: '#e8ffef', border: '#a4e6c1' },
  red: { color: '#f53f3f', background: '#fff1f0', border: '#ffccc7' },
  purple: { color: '#722ed1', background: '#f5f0ff', border: '#d3adf7' },
  gray: { color: '#86909c', background: '#f2f3f5', border: '#c9cdd4' }
};

type Props = {
  children: ReactNode;
  tone?: MobileTagTone;
  className?: string;
};

function MobileTag({ children, tone = 'blue', className = '' }: Props) {
  const colors = tagTones[tone];
  return <Tag className={`mobile-ui-tag ${className}`.trim()} size="small" type="hollow" filleted={false}
    color={colors.color} bgColor={colors.background} borderColor={colors.border} halfBorder={false}>
    {children}
  </Tag>;
}

export default MobileTag;
